export const REQUEST_PREOPEN_MANAGER_VALIDATED_CLAIMS: string =
  'REQUEST_PREOPEN_MANAGER_VALIDATED_CLAIMS';
export const SET_PREOPEN_MANAGER_VALIDATED_CLAIMS: string =
  'SET_PREOPEN_MANAGER_VALIDATED_CLAIMS';

export const REQUEST_SEARCH: string = 'REQUEST_SEARCH';
export const SET_SEARCH: string = 'SET_SEARCH';

export const SEARCH_TYPE = {
  CLAIM: 'CLAIM',
  ASSIGNMENT: 'ASSIGNMENT',
};
